export default {
  "start": {
    "twoMinutes": "2 Minutos",
    "safeAndSecure": "Seguro y Confiable",
    "multipleOffers": "Múltiples Ofertas",
    "variants": {
      "default": {
        "headline": "Obtén tu Préstamo Personal en minutos",
        "subheadline": "Consulta tu tasa sin afectar tu puntaje de crédito",
        "ctaText": "Consulta Tu Tasa"
      },
      "debt_consolidation": {
        "headline": "Consolida Tu Deuda Hoy",
        "subheadline": "Simplifica tus pagos con un pago mensual fijo",
        "ctaText": "Consolidar Mi Deuda"
      },
      "home_improvement": {
        "headline": "Financia el Proyecto de Tu Hogar",
        "subheadline": "Obtén los fondos que necesitas para renovaciones y mejoras",
        "ctaText": "Obtener Mi Préstamo para el Hogar"
      },
      "emergency_fund": {
        "headline": "Obtén Fondos de Emergencia Rápido",
        "subheadline": "Accede a fondos rápidamente cuando la vida te sorprenda",
        "ctaText": "Obtener Fondos de Emergencia"
      },
      "personalized": {
        "headline": "Eres Elegible para un Préstamo Personal",
        "subheadline": "Completa tu solicitud para acceder a tu oferta personalizada",
        "ctaText": "Acceder a Mi Oferta",
        "headlineWithName": "Hola {{firstName}}, eres elegible para un Préstamo Personal",
        "headlineWithNameAndAmount": "Hola {{firstName}}, eres elegible para hasta {{amount}}"
      }
    }
  },
  "email": {
    "title": "¿Cuál es tu correo electrónico?",
    "description": "Lo usaremos para enviarte actualizaciones importantes sobre tu solicitud",
    "submit": "Continuar",
    "requiredError": "Ingresa tu dirección de correo electrónico"
  },
  "birthDate": {
    "title": "¿Cuál es tu fecha de nacimiento?",
    "description": "Ingresa tu fecha de nacimiento para confirmar tu elegibilidad (debes ser mayor de 18 años)",
    "submit": "Continuar",
    "requiredError": "Ingresa tu fecha de nacimiento"
  },
  "contactInfo": {
    "title": "Ingresa Tu Número de Teléfono",
    "phoneLabel": "Teléfono Móvil",
    "submit": "Continuar",
    "processing": "Procesando...",
    "cooldownMessage_one": "Has alcanzado el número máximo de intentos para verificar tu información de contacto. Por tu seguridad, espera {{count}} minuto antes de volver a intentarlo.",
    "cooldownMessage_other": "Has alcanzado el número máximo de intentos para verificar tu información de contacto. Por tu seguridad, espera {{count}} minutos antes de volver a intentarlo.",
    "retryIn": "Inténtalo de nuevo en {{time}}",
    "smsDisclaimer": "Al continuar, aceptas recibir mensajes SMS, llamadas telefónicas y correos electrónicos, posiblemente mediante tecnología automatizada o voz artificial/pregrabada, de Symple Lending y sus socios de préstamos (\"<partnersLink>Socios</partnersLink>\") sobre actualizaciones de tu solicitud y comunicaciones relacionadas con tu cuenta. Pueden aplicar tarifas de mensajes/datos; la frecuencia varía. Responde HELP para ayuda o STOP para cancelar.",
    "creditDisclaimer": "Al continuar, también otorgas a Symple Lending y sus <partnersLink>Socios</partnersLink> tu consentimiento expreso por escrito para obtener tu reporte de crédito con fines de solicitud. También aceptas el <spinwheelLink>Acuerdo de Usuario Final de Spinwheel</spinwheelLink> y autorizas a Spinwheel Solutions, Inc. a obtener tu perfil de crédito de cualquier agencia de reportes de crédito."
  },
  "verificationCooldown": {
    "message_one": "Has alcanzado el número máximo de intentos para este método de verificación. Por tu seguridad, espera {{count}} minuto antes de volver a intentarlo.",
    "message_other": "Has alcanzado el número máximo de intentos para este método de verificación. Por tu seguridad, espera {{count}} minutos antes de volver a intentarlo."
  },
  "phoneVerification": {
    "title": "Revisa Tus Mensajes de Texto",
    "description": "Ingresa el código de 6 dígitos antes de que caduque",
    "mobilePhoneLabel": "Teléfono Móvil:",
    "birthDateLabel": "Fecha de Nacimiento:",
    "promoConsent": "(Opcional) Acepto recibir actualizaciones de productos y ofertas promocionales de Symple Lending y sus Socios mediante mensajes SMS, llamadas telefónicas, correos electrónicos u otros métodos, que pueden usar tecnología automatizada o voz artificial/pregrabada. El consentimiento no es una condición de compra. Pueden aplicar tarifas de mensajes/datos; la frecuencia varía. Responde HELP para ayuda o STOP para cancelar.",
    "verifying": "Verificando...",
    "submit": "Obtener Mis Resultados",
    "resend": "Reenviar código de verificación",
    "reenter": "Actualizar teléfono móvil/fecha de nacimiento"
  },
  "loanAmount": {
    "title": "Monto del Préstamo",
    "descriptionDefault": "¿Cuánto te gustaría solicitar en préstamo?",
    "descriptionOffer": "Calificas para {{amount}}. Puedes ajustarlo si lo necesitas.",
    "originalOffer": "Oferta original:",
    "submit": "Continuar",
    "decreaseAria": "Disminuir monto",
    "increaseAria": "Aumentar monto"
  },
  "loanPurpose": {
    "title": "Propósito del Préstamo",
    "description": "¿Cuál es la razón principal de este préstamo?",
    "options": {
      "debt_consolidation": {
        "label": "Consolidación de Deudas",
        "description": "Combina varias deudas en un solo pago"
      },
      "credit_card_refi": {
        "label": "Refinanciamiento de Tarjeta de Crédito",
        "description": "Refinancia deuda de tarjeta de crédito con interés alto"
      },
      "emergency": {
        "label": "Gastos de Emergencia",
        "description": "Cubre costos inesperados o emergencias"
      },
      "home_improvement": {
        "label": "Mejoras del Hogar",
        "description": "Renueva o repara tu hogar"
      },
      "large_purchases": {
        "label": "Compras Grandes",
        "description": "Financia gastos o compras importantes"
      },
      "other": {
        "label": "Otro",
        "description": "Otros gastos personales"
      }
    }
  },
  "propertyStatus": {
    "title": "Situación de Vivienda",
    "description": "¿Cuál es tu situación de vivienda actual?",
    "options": {
      "own_outright": {
        "label": "Casa Propia sin Hipoteca",
        "description": "Eres propietario de tu casa sin hipoteca"
      },
      "own_with_mortgage": {
        "label": "Casa Propia con Hipoteca",
        "description": "Eres propietario de tu casa y tienes una hipoteca"
      },
      "rent": {
        "label": "Renta",
        "description": "Rentas tu vivienda"
      }
    }
  },
  "employmentStatus": {
    "title": "Situación Laboral",
    "description": "¿Qué describe mejor tu situación laboral actual?",
    "options": {
      "employed_full_time": {
        "label": "Empleado a Tiempo Completo",
        "description": "40+ horas por semana"
      },
      "employed_part_time": {
        "label": "Empleado a Tiempo Parcial",
        "description": "Menos de 40 horas por semana"
      },
      "self_employed": {
        "label": "Trabajador Independiente",
        "description": "Dueño de negocio o freelancer"
      },
      "military": {
        "label": "Militar",
        "description": "Servicio militar activo o de reserva"
      },
      "employed": {
        "label": "Otro Tipo de Empleo",
        "description": "Otro tipo de arreglo laboral"
      },
      "retired": {
        "label": "Jubilado",
        "description": "Recibe ingresos de jubilación"
      },
      "not_employed": {
        "label": "Actualmente Sin Empleo",
        "description": "No está trabajando en este momento"
      },
      "other": {
        "label": "Otro",
        "description": "Ninguna de las anteriores"
      }
    }
  },
  "employmentFrequency": {
    "title": "Frecuencia de Pago",
    "description": "¿Con qué frecuencia recibes tu pago?",
    "options": {
      "weekly": {
        "label": "Semanal",
        "description": "Pago una vez por semana"
      },
      "biweekly": {
        "label": "Quincenal",
        "description": "Pago cada dos semanas"
      },
      "twice_monthly": {
        "label": "Dos Veces al Mes",
        "description": "Pago dos veces al mes (por ejemplo, el 1 y el 15)"
      },
      "monthly": {
        "label": "Mensual",
        "description": "Pago una vez al mes"
      }
    }
  },
  "annualIncome": {
    "title": "Ingreso Anual",
    "description": "¿Cuál es tu ingreso anual total?",
    "tooltip": "El ingreso anual total es tu “ingreso bruto antes de impuestos.”",
    "decreaseAria": "Disminuir ingreso",
    "increaseAria": "Aumentar ingreso",
    "submit": "Continuar",
    "disclaimer": "Indica tu ingreso total disponible, incluyendo salarios, jubilación, inversiones y propiedades de alquiler. La pensión alimenticia, manutención de menores o manutención por separación es opcional y no es necesario incluirla si no deseas que se considere como base para pagar el préstamo. Aumenta cualquier ingreso o beneficio no imponible en un 25%."
  },
  "education": {
    "title": "Nivel de Educación",
    "description": "¿Cuál es tu nivel de educación más alto?",
    "options": {
      "did_not_graduate": {
        "label": "No se Graduó",
        "description": "No completó la escuela secundaria"
      },
      "high_school": {
        "label": "Escuela Secundaria",
        "description": "Diploma de escuela secundaria o GED"
      },
      "still_enrolled": {
        "label": "Actualmente Inscrito",
        "description": "Actualmente cursando un título"
      },
      "certificate": {
        "label": "Certificado/Certificación",
        "description": "Certificación profesional o escuela técnica"
      },
      "associate": {
        "label": "Título de Asociado",
        "description": "Título universitario de 2 años"
      },
      "bachelors": {
        "label": "Título de Licenciatura",
        "description": "Título universitario de 4 años"
      },
      "masters": {
        "label": "Título de Maestría",
        "description": "Título de posgrado"
      },
      "doctorate": {
        "label": "Doctorado",
        "description": "Ph.D. u otro título doctoral"
      },
      "other_grad_degree": {
        "label": "Otro Título de Posgrado",
        "description": "Otro título avanzado"
      },
      "other": {
        "label": "Otro",
        "description": "Otra formación educativa"
      }
    }
  },
  "ssnVerification": {
    "title": "Verifica Tu Identidad",
    "description": "Ingresa los últimos 4 dígitos de tu Número de Seguro Social",
    "tooltip": "Usamos tu número de seguro social para validar tu información y revisar tu crédito. Esto NO afectará tu puntaje de crédito. Tu información se transmite de forma segura.",
    "tooltipSrLabel": "Cómo usamos tu SSN",
    "placeholder": "Últimos 4 dígitos",
    "disclaimerIntro": "Al hacer clic en \"Enviar Solicitud\" arriba:",
    "disclaimerConsent": "Doy mi consentimiento para que Symple Lending envíe mi solicitud a sus <partnersLink>Socios</partnersLink> para evaluar mi elegibilidad para ofertas de préstamos personales y productos y servicios financieros relacionados. Al continuar, también otorgas a Symple Lending y a sus Socios tu consentimiento expreso por escrito para obtener tu reporte de crédito con fines de solicitud.",
    "disclaimerAck": "Reconozco que cada <partnerLink>Socio</partnerLink> tiene sus propias prácticas de privacidad y términos de consentimiento. Para ver la lista completa de <partnersLink2>Socios</partnersLink2> y su lenguaje de consentimiento, visita <consentsLink>Consentimientos y Divulgaciones de los Socios de Préstamos</consentsLink>.",
    "submitting": "Enviando...",
    "submit": "Enviar Solicitud"
  },
  "applicationReview": {
    "title": "Terminemos tu solicitud de préstamo",
    "description": "Hemos recibido tu información de nuestro socio. Confirma o actualiza tus datos a continuación.",
    "detailsHeading": "Detalles de Tu Solicitud",
    "rowLabels": {
      "loanAmount": "Monto del Préstamo",
      "loanPurpose": "Propósito del Préstamo",
      "employmentStatus": "Situación Laboral",
      "propertyStatus": "Situación de Vivienda"
    },
    "notSpecified": "No especificado",
    "continue": "Continuar",
    "editDetails": "Editar Detalles"
  },
  "kbaPersonalInfo": {
    "title": "Verifica Tu Identidad",
    "description": "Confirma tus datos personales para que podamos verificar tu identidad",
    "selectStatePlaceholder": "-- Selecciona tu estado --",
    "firstNameLabel": "Nombre",
    "lastNameLabel": "Apellido",
    "streetLabel": "Dirección",
    "aptSuiteLabel": "Apto/Suite",
    "cityLabel": "Ciudad",
    "stateLabel": "Estado",
    "zipLabel": "Código Postal",
    "zipError": "Ingresa un código postal válido de 5 dígitos",
    "saving": "Guardando...",
    "submit": "Continuar"
  },
  "kbaSsn": {
    "title": "Número de Seguro Social",
    "description": "Ingresa tu Número de Seguro Social completo para verificar tu identidad",
    "tooltip": "Usamos tu SSN para verificar tu identidad y revisar tu elegibilidad. Esto NO afectará tu puntaje de crédito. Tu información se transmite de forma segura.",
    "tooltipSrLabel": "Cómo usamos tu SSN",
    "placeholder": "Ingresa tu SSN de 9 dígitos",
    "showAria": "Mostrar SSN",
    "hideAria": "Ocultar SSN",
    "firstNameLabel": "Nombre:",
    "lastNameLabel": "Apellido:",
    "streetLabel": "Dirección:",
    "cityLabel": "Ciudad:",
    "stateLabel": "Estado:",
    "zipLabel": "Código Postal:",
    "birthDateLabel": "Fecha de Nacimiento:",
    "verifying": "Verificando...",
    "submit": "Continuar",
    "updatePersonalInfo": "Actualizar datos personales",
    "updateBirthDate": "Actualizar fecha de nacimiento"
  },
  "kbaQuestions": {
    "title": "Preguntas de Seguridad",
    "description": "Responde las siguientes preguntas para verificar tu identidad",
    "questionOf": "Pregunta {{current}} de {{total}}",
    "submitting": "Enviando...",
    "submit": "Enviar Respuestas"
  },
  "manualVerification": {
    "title": "Verificación Manual",
    "description": "Proporciona información adicional para verificar tu identidad",
    "selectStatePlaceholder": "-- Selecciona tu estado --",
    "offerCodeLabel": "Código de Oferta",
    "firstNameLabel": "Nombre",
    "lastNameLabel": "Apellido",
    "streetLabel": "Dirección",
    "aptSuiteLabel": "Apto/Suite",
    "cityLabel": "Ciudad",
    "stateLabel": "Estado",
    "zipLabel": "Código Postal",
    "zipError": "Ingresa un código postal válido de 5 dígitos",
    "verifying": "Verificando...",
    "submit": "Enviar",
    "tryPhoneAgain": "Intentar Verificación por Teléfono Otra Vez"
  },
  "reenterContact": {
    "title": "Actualizar Número de Teléfono",
    "description": "Ingresa tu número de teléfono móvil",
    "placeholder": "(555) 555-5555",
    "next": "Siguiente"
  },
  "formatting": {
    "notSpecified": "No especificado",
    "loanPurpose": {
      "debt_consolidation": "Consolidación de Deudas",
      "credit_card_refi": "Refinanciamiento de Tarjeta de Crédito",
      "emergency": "Gastos de Emergencia",
      "home_improvement": "Mejoras del Hogar",
      "large_purchases": "Compras Grandes",
      "other": "Otro"
    },
    "employmentStatus": {
      "employed": "Empleado",
      "employed_full_time": "Empleado a Tiempo Completo",
      "employed_part_time": "Empleado a Tiempo Parcial",
      "military": "Militar",
      "not_employed": "Sin Empleo",
      "self_employed": "Trabajador Independiente",
      "retired": "Jubilado",
      "other": "Otro"
    },
    "propertyStatus": {
      "own_outright": "Casa Propia sin Hipoteca",
      "own_with_mortgage": "Casa Propia con Hipoteca",
      "rent": "Renta"
    },
    "educationLevel": {
      "high_school": "Escuela Secundaria o GED",
      "associate": "Título de Asociado",
      "bachelors": "Título de Licenciatura",
      "masters": "Título de Maestría",
      "doctorate": "Doctorado",
      "other_grad_degree": "Otro Título de Posgrado",
      "certificate": "Certificado/Certificación",
      "did_not_graduate": "No se Graduó",
      "still_enrolled": "Actualmente Inscrito",
      "other": "Otro"
    }
  }
} as const;
